import PropTypes from 'prop-types';

export const scrollElementRefPropType = PropTypes.shape({
  current: PropTypes.instanceOf(
    typeof Element === 'undefined' ? Object : Element
  ),
});

export const virtualizerRefPropType = PropTypes.shape({
  current: PropTypes.object,
});

export const domRefPropType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: PropTypes.any }),
]);

export const baseVirtualizedListPropTypes = {
  className: PropTypes.string,
  overlayWrapperClass: PropTypes.string,
  viewportClass: PropTypes.string,
  itemClass: PropTypes.string,
  verticalScrollClass: PropTypes.string,
  horizontalScrollClass: PropTypes.string,
  virtualizerRef: virtualizerRefPropType,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isDynamicSize: PropTypes.bool,
  hasNextPage: PropTypes.bool,
  isNextPageLoading: PropTypes.bool,
  renderItem: PropTypes.func,
  onLoadMore: PropTypes.func,
};

export const virtualizerConfigPropTypes = {
  count: PropTypes.number,
  gap: PropTypes.number,
  estimateSize: PropTypes.func.isRequired,
  getItemKey: PropTypes.func.isRequired,
};
